import { useFeatureFlag } from 'featureFlags';
import { useSngPayouts } from 'hooks/useSngPayouts';

/** Preload real, accessible SnGs as soon as the lobby feed arrives. */
export default function PayoutPreload({
  id,
  revision,
  keepFresh = true
}: {
  id: number;
  revision: string;
  keepFresh?: boolean;
}) {
  const enabled = useFeatureFlag('sngPayoutStructure');
  useSngPayouts(id, enabled, revision, keepFresh);
  return null;
}
